var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVkLogoBig(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 13,
    width: 49,
    height: 38,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.49884 4.49884C0 8.99768 0 16.2385 0 30.72V33.28C0 47.7615 0 55.0023 4.49884 59.5012C8.99768 64 16.2385 64 30.72 64H33.28C47.7615 64 55.0023 64 59.5012 59.5012C64 55.0023 64 47.7615 64 33.28V30.72C64 16.2385 64 8.99768 59.5012 4.49884C55.0023 0 47.7615 0 33.28 0H30.72C16.2385 0 8.99768 0 4.49884 4.49884ZM10.6667 19.6C11.0093 36.2481 19.7538 46.2667 34.167 46.2667H35.0031V36.7425C40.2523 37.2753 44.1669 41.1997 45.765 46.2667H53.3333C51.2802 38.6868 45.9567 34.4959 42.6481 32.8949C45.9542 30.9148 50.6333 26.1142 51.7353 19.6H44.8496C43.405 24.8975 39.1069 29.698 35.0005 30.1539V19.6H28.0049V38.0771C23.7477 37.0115 18.1941 31.8293 17.9666 19.6H10.6667Z",
    fill: "#2D81E0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVkLogoBig);
export default __webpack_public_path__ + "static/media/vk_logo_big.56336cff1b8619efd74d4daa9d1dde0a.svg";
export { ForwardRef as ReactComponent };